import { useState } from 'react'

export const useAutoComplete = () => {
  const [keyword, setKeyword] = useState('')
  const [focused, setFocused] = useState(false)

  const hasKeyword = () => {
    return keyword.length > 0
  }

  const updateKeyword = (keyword: string) => {
    setKeyword(keyword)
  }

  const updateFocusStatus = (focused: boolean) => {
    setFocused(focused)
  }

  return {
    keyword,
    hasKeyword,
    updateKeyword,
    focused,
    updateFocusStatus,
  }
}
